const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinancials(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.444,
    height: 18.444,
    viewBox: "0 0 18.444 18.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5062",
    d: "M2.113 0A2.113 2.113 0 0 0 0 2.113v6.725h8.838V0zm3.459 5.188H4.8v.769a.576.576 0 0 1-1.153 0v-.769h-.765a.576.576 0 1 1 0-1.153h.768v-.769a.576.576 0 0 1 1.153 0v.769h.769a.576.576 0 0 1 0 1.153z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5063",
    d: "M0 12.5v6.725a2.113 2.113 0 0 0 2.113 2.113h6.725V12.5zm5.787 4.972a.576.576 0 1 1-.815.815l-.553-.553-.553.553a.576.576 0 0 1-.815-.815l.553-.553-.553-.553a.577.577 0 0 1 .815-.815l.553.553.553-.553a.577.577 0 0 1 .815.815l-.553.553z",
    transform: "translate(0 -2.894)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5064",
    d: "M19.225 0H12.5v8.838h8.838V2.113A2.113 2.113 0 0 0 19.225 0zm-.385 5h-3.458a.576.576 0 0 1 0-1.153h3.458a.576.576 0 1 1 0 1.153z",
    transform: "translate(-2.894)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5065",
    d: "M12.5 12.5v8.838h6.725a2.113 2.113 0 0 0 2.113-2.113V12.5zm6.148 6.148H15.19a.576.576 0 0 1 0-1.153h3.458a.576.576 0 0 1 0 1.153zm0-2.306H15.19a.576.576 0 0 1 0-1.153h3.458a.576.576 0 0 1 0 1.153z",
    transform: "translate(-2.894 -2.894)",
    style: {
      fill: "#d9d9d9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancials);
export default __webpack_public_path__ + "static/media/financials.4b24a8850284fb4798dbfc7976b8ab49.svg";
export { ForwardRef as ReactComponent };